import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import translateString from '../utils/Locales';
import HelpWidget from '../widgets/HelpWidget';
import { helps } from '../utils/helps'; 
import { helps_en } from '../utils/help_en';

let t = translateString;
var checkPageInterval = undefined;

class Help extends React.Component {
    constructor(props) {
        super(props);

        this.gridX = props.gridX || 1;
        this.gridY = props.gridY || 1;
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);

        if (t('language_string') === 'it') {
            this.list = helps;
        } else {
            this.list = helps_en;
        }

        this.state = {
            page: props.page,
            relX: 0,
            relY: 0,
            x: props.x,
            y: props.y, 
            isLoading: true,
        };
    }

    static propTypes = {
        onMove: PropTypes.func,
        onStop: PropTypes.func,
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired,
        gridX: PropTypes.number,
        gridY: PropTypes.number
    }; 

    onStart(e) {
        const ref = ReactDOM.findDOMNode(this.handle);
        const body = document.body;
        const box = ref.getBoundingClientRect();
        this.setState({
            relX: e.pageX - (box.left + body.scrollLeft - body.clientLeft),
            relY: e.pageY - (box.top + body.scrollTop - body.clientTop)
        });
    }

    onMove(e) {
        const x = Math.trunc((e.pageX - this.state.relX) / this.gridX) * this.gridX;
        const y = Math.trunc((e.pageY - this.state.relY) / this.gridY) * this.gridY;
        if (x !== this.state.x || y !== this.state.y) {
            this.setState({
                x,
                y
            });
            this.props.onMove && this.props.onMove(this.state.x, this.state.y);
        }        
    }

    onMouseDown(e) {
        if (e.button !== 0) return;
        this.onStart(e);
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onMouseUp);
        e.preventDefault();
    }

    onMouseUp(e) {
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
        this.props.onStop && this.props.onStop(this.state.x, this.state.y);
        e.preventDefault();
    }

    onMouseMove(e) {
        this.onMove(e);
        e.preventDefault();
    }

    onTouchStart(e) {
        this.onStart(e.touches[0]);
        document.addEventListener('touchmove', this.onTouchMove, {passive: false});
        document.addEventListener('touchend', this.onTouchEnd, {passive: false});
        e.preventDefault();
    }

    onTouchMove(e) {
        this.onMove(e.touches[0]);
        e.preventDefault();
    }

    onTouchEnd(e) {
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
        this.props.onStop && this.props.onStop(this.state.x, this.state.y);
        e.preventDefault();
    }

    componentDidMount() {

        let chunks = window.location.hash.split('/');
        var page = chunks[chunks.length - 1];

        if (window.location.hash.includes('billing')) {
            this.info = this.list.find((p) => p.titolo === 'billing/' + page);
        } else {
            this.info = this.list.find((p) => p.titolo === page)
        }

        if (this.info) {
            this.setState({ isLoading: false });
        } else {
            if (this.props.onClose) this.props.onClose();
        }

        this.checkPage();
    }

    checkPage() {

        checkPageInterval = setInterval(() => {
            
            if (!window.location.hash.includes('billing')) {
                let chunks = window.location.hash.split('/');
                let p = chunks[chunks.length - 1];
                this.info = this.list.find((pa) => pa.titolo === p);
            } else {
                let chunks = window.location.hash.split('/');
                let p = chunks[chunks.length - 1];
                this.info = this.list.find((pa) => pa.titolo === 'billing/' + p);
            }
        }, 500);
    }

    componentWillUnmount() {
        clearInterval(checkPageInterval);
    }

    render() {

        if (this.state.isLoading || !this.info) return <div />;

        return <div
            onMouseDown={this.onMouseDown}
            onTouchStart={this.onTouchStart}
            style={{
                position: 'absolute',
                left: this.state.x,
                top: this.state.y,
                touchAction: 'none', 
                zIndex: 10000, 
                boxShadow: '0px 2px 10px lightgrey',
                width: 500, 
                borderRadius: 10, 
                backgroundColor: 'white',
                height: window.innerHeight - 100, 
                overflowX: 'hidden', 
                overflowY: 'scroll',
            }}
            ref={(div) => { this.handle = div; }}
        >
            <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: 80, backgroundColor: '#ECECEC' }}>
                <h3 style={{ position: 'absolute', top: 25, left: 30, fontWeight: 'bold' }}>{t('aiuto')}</h3>
                <img src={ require('../images/close_icon.png') } style={{ position: 'absolute', top: 30, right: 30, width: 20, height: 20, cursor: 'pointer' }} onClick={() => this.props.onClose && this.props.onClose() } />
            </div>
            
            <div style={{ position: 'absolute', top: 80, left: 0, right: 0, width: '100%', padding: 20 }}>
                <p style={{ color: 'grey' }}>{t('sel_aiuto')}</p>
                <section style={{ marginTop: 20 }}>
                    { this.info.titoli_sezioni.map((titolo, ind) => {

                        return(
                            <HelpWidget key={ind} titolo={titolo} text={this.info.sezioni[ind]} immagini={this.info.immagini[ind]} />
                        );
                    })}
                </section>
            </div>

        </div>;
    }
}

export default Help;